module.exports = __webpack_public_path__ + "static/media/auth-bg.c7dbdfa5.png";